import { render, staticRenderFns } from "./AssignProductModal.vue?vue&type=template&id=f6fe1fac&"
import script from "./AssignProductModal.vue?vue&type=script&lang=js&"
export * from "./AssignProductModal.vue?vue&type=script&lang=js&"
import style0 from "./AssignProductModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports